const areaCreator = {
	path: 'area-creator',
	component: () => import('@/views/member/area-creator/index.vue'),
	meta:{
		tabBar:'office'
	},
	children:[{
		path:'await-pay',
		component: () => import('@/views/member/area-creator/await-pay.vue'),
    meta:{
      tabBar:'office'
    },
	},{
		path:'history-data',
		component: () => import('@/views/member/area-creator/history-data.vue'),
    meta:{
      tabBar:'office'
    },
	},{
		path:'store-income',
		component: () => import('@/views/member/area-creator/store-income.vue'),
    meta:{
      tabBar:'office'
    },
	},{
		path:'store-income-detail',
		component: () => import('@/views/member/area-creator/store-income-detail.vue'),
    meta:{
      tabBar:'office'
    },
	}]
};

export default areaCreator;